import { Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { ViewStudyStatus } from '../../models/view/view-study-status';
import { ViewSendingStatus } from '../../models/view/view-sending-status';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnChanges {

    @Input() status: ViewStudyStatus;

    warningMessage: string = 'StudyPatientMatchMessage';
    errorMessage: string = 'StudyUploadErrorMessage';
    successMessage: string = 'StudyUploadSuccessMessage';

    showError: boolean;
    showWarning: boolean;
    showSuccess: boolean;
    delay = 500;

    constructor() {
        this.status = {
            selected: false,
            patientNotEqual: false,
            sendingStatus: ViewSendingStatus.NOT_SENT
        };
        this.showError = false;
        this.showWarning = false;
        this.showSuccess = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['status']) {
            this.updateFeedback();
        }
    }

    private updateFeedback() {
        this.showError = this.status.sendingStatus === ViewSendingStatus.ERROR;
        this.showWarning = this.status.patientNotEqual;
        this.showSuccess = this.status.sendingStatus === ViewSendingStatus.SENT;
    }
}
